import PremiumFolderSlider from './PremiumFolderSlider';
import PremiumFolderSliderContainer from './PremiumFolderSlider.container';

export default PremiumFolderSliderContainer(PremiumFolderSlider);
